import Swiper from "swiper";
import { FreeMode, Mousewheel, Scrollbar } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/scrollbar";

if (document.querySelector('.filter-list.swiper')) {
    new Swiper('.filter-list.swiper', {
        modules: [FreeMode, Mousewheel, Scrollbar],
        slidesPerView: 'auto',
        spaceBetween: 10,
        freeMode: true,
        grabCursor: true,
        observer: true,
        observeParents: true,
        mousewheel: {
            forceToAxis: true,
        },
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
        },
        breakpoints: {
            768: {
                spaceBetween: 10,
            }
        }
    });
}
